
const incrementAttr = (oldPost, uuid, accessor, callback) => {
  if (oldPost && oldPost?.uuid === uuid) {
    oldPost[accessor] += 1
    callback && callback(oldPost)
  }
  return oldPost
}

const decrementAttr = (oldPost, uuid, accessor, callback) => {
  if (oldPost && oldPost?.uuid === uuid) {
    oldPost[accessor] -= 1
    callback && callback(oldPost)
  }
  return oldPost
}

export { incrementAttr, decrementAttr }
